import React, { useEffect, useState } from "react";
import Tour, { ReactourStep } from "reactour";
import { Button } from "../common-components/Button";

const steps: ReactourStep[] = [
  {
    selector: "[data-tour-id='distance-selector-0']",
    content: "Select the distance to refine the interval",
  },
  {
    selector: "[data-tour-id='time-selector-0']",
    content: "Select the time to adjust the pace using the slider",
  },
];

type Props = {
  isOpen: boolean;
  onTourComplete: () => void;
};
export const HelpTour = React.memo(({ isOpen, onTourComplete }: Props) => {
  const [isTourActive, setIsTourActive] = useState(false);

  useEffect(() => {
    setIsTourActive(isOpen);
  }, [isOpen]);

  const onTourClose = () => {
    setIsTourActive(false);
    onTourComplete();
  }

  return (
    <Tour
      steps={steps}
      isOpen={isTourActive}
      onRequestClose={onTourClose}
      accentColor="#00301b"
      rounded={8}
      closeWithMask={true}
      lastStepNextButton={(<Button actionable={true} text={"Done"}/>)}
      disableInteraction={true}
    />
  );
});
